/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-11-30 18:57:40
 */

import {Component} from 'vue-property-decorator'
import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
import override from "src/dectorators/override";
import {StationConfigDOI} from "./api/stationConfigApi";
import StationConfigService from "./service/stationConfigService";
import './stationConfig.less';
import { createNamespace } from 'src/util/bem';

@Component({name: 'station-config'})
export default class StationConfig extends BasicSearchPage<StationConfigService, StationConfigDOI.RowDataI, StationConfigDOI.QueryRowDataParamsI> {
    className=createNamespace('station-config')
    checkBoxShow = true;
    
    @override
    renderHead(h) {
        return <div></div>
    }

	@override
	loadService () {
		this.service = new StationConfigService(this)
	}
}
